import { IController } from 'angular';
import * as _ from 'lodash';

import { IPriorityGroupDefinition } from './../../../../../../../shared/services/credit-gaps-priority-groupings/credit-gaps-priority-groupings.service';
// tslint:disable-next-line:max-line-length
import { RegentsPlanningPriorityGroupingsService } from './../../../../../../../shared/services/regents-planning-priority-groupings/regents-planning-priority-groupings.service';
import { WizardUtils } from './../../../../../../../shared/services/wizard-utils/wizard-utils.service';
import { IWizardFilterActionsOptions } from './../../../../../components/wizard-filter-actions/wizard-filter-actions.typings';

// tslint:disable-next-line:max-line-length
// tslint:disable-next-line:max-line-length
interface IPriorityGroupTable extends IPriorityGroupDefinition {
  studentIds: string[];
}

export class PriorityGroupCtrl implements IController {
  static $inject: string[] = ['$scope', 'WizardUtils', 'RegentsPlanningPriorityGroupingsService'];

  public filteredStudents; // sdc students
  public priorityGroupsTable: IPriorityGroupTable[];
  public options: IWizardFilterActionsOptions;
  public currentFilter;

  constructor(
    public $scope,
    private WizardUtils: WizardUtils,
    private RegentsPlanningPriorityGroupingsService: RegentsPlanningPriorityGroupingsService,
  ) {}

  $onInit(): void {
    this.WizardUtils.startListeningAndLoad(this);
  }

  setUi(): void {
    this.currentFilter = _.last(this.WizardUtils.getCurrentCohortFilter());
    this.filteredStudents = this.WizardUtils.getFilteredFlattenedStudents();
    this.priorityGroupsTable = this.buildPriorityGroupTable();
    this.options = {
      columnKeys: [
        'cohort',
        'regentsNeededForOnTrackDiploma',
        'regentsNeededForOnTrackDiplomaNotSched',
        'regentsSchedForNextAdmin',
      ],
    };
  }

  private buildPriorityGroupTable(): IPriorityGroupTable[] {
    const priorityGrouping = this.RegentsPlanningPriorityGroupingsService.getPriorityGroupsByStudentYearFilter();
    const priorityGroupsWithAppendedField = _.map(priorityGrouping, (group: IPriorityGroupTable) => {
      group.studentIds = [];
      return group;
    });
    _.each(this.filteredStudents, ({ regentsPlanningPriorityGrouping, studentId }: any) => {
      // sdc student
      const matchedPriorityGroup = _.find(priorityGroupsWithAppendedField, {
        studentPriorityGroupingValue: regentsPlanningPriorityGrouping,
      });
      if (!matchedPriorityGroup) return;
      matchedPriorityGroup.studentIds.push(studentId);
    });
    return priorityGroupsWithAppendedField.slice(0, -1); // remove `none`
  }
}
